export const enum EFormProfileStatus {
  profile = 'PROFILE',
  contracts = 'CONTRACTS',
  addendum = 'ADDENDUM',
}
